module.exports = {
  enableMonitor: true,
	TAMProjectIDNode: 'jUjXEnQXWjfchxhKez',
	TAMProjectIDClient: 'jUjXEnQXZRgAfQbizh',
};